import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionItemCategoryApi = {
    getTrialInstitutionItemCategoriesByTrialInstitutionId: (trialInstitutionId?: number): Observable<Dtos.GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemCategoriesByTrialInstitutionId = new Dtos.GetTrialInstitutionItemCategoriesByTrialInstitutionId();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemCategoriesByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}